const CARD_BORDER = "1px solid rgba(234, 234, 234, 1)";
const TEXT_MAIN = "rgba(47, 43, 61, 0.9)";
const TEXT_SUB = "rgba(71, 84, 103, 1)";
const GREEN = "rgba(36, 139, 112, 1)";
const GREEN_TINT = "rgba(219, 240, 236, 1)";

export const dashboardStyles = {
  page: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    marginTop: { xs: "75px", md: "0px" },
    paddingBottom: "24px",
  },
  header: { display: "flex", alignItems: "center", gap: "12px", marginBottom: "4px" },
  headerLogo: {
    width: 36,
    height: 36,
    fontSize: "15px",
    bgcolor: "rgba(242, 243, 251, 1)",
    color: "rgba(62, 63, 76, 0.7)",
  },
  title: {
    color: "rgba(62, 63, 76, 0.9)",
    fontSize: { xs: "20px", md: "24px" },
    fontWeight: 600,
    lineHeight: 1.2,
  },
  chartGrid: {
    display: "grid",
    gridTemplateColumns: { xs: "minmax(0, 1fr)", md: "repeat(2, minmax(0, 1fr))" },
    gap: "16px",
  },
  midGrid: {
    display: "grid",
    gridTemplateColumns: { xs: "minmax(0, 1fr)", md: "minmax(0, 1fr) minmax(0, 1fr)" },
    gap: "16px",
  },
  topGrid: {
    display: "grid",
    gridTemplateColumns: { xs: "minmax(0, 1fr)", md: "repeat(3, minmax(0, 1fr))" },
    gap: "16px",
  },
  // Four top tables are too narrow side by side on a laptop: 2×2 until xl.
  topGridFour: {
    display: "grid",
    gridTemplateColumns: {
      xs: "minmax(0, 1fr)",
      md: "repeat(2, minmax(0, 1fr))",
      xl: "repeat(4, minmax(0, 1fr))",
    },
    gap: "16px",
  },
  healthGrid: {
    display: "grid",
    gridTemplateColumns: { xs: "minmax(0, 1fr)", sm: "repeat(2, minmax(0, 1fr))" },
    gridTemplateRows: { sm: "1fr 1fr" },
    gap: "12px",
    height: "100%",
  },
  qualityGrid: {
    display: "grid",
    gridTemplateColumns: { xs: "minmax(0, 1fr)", md: "minmax(0, 1fr) minmax(0, 1fr)" },
    gap: "16px",
  },
  qualityHeaderRow: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    flexWrap: "wrap",
    marginTop: "8px",
  },
  sectionHeader: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    marginTop: "8px",
  },
  sectionTitle: {
    fontSize: "18px",
    fontWeight: 500,
    color: "rgba(47, 43, 61, 0.9)",
  },
};

export const statCardStyles = {
  card: {
    border: CARD_BORDER,
    borderRadius: "12px",
    backgroundColor: "#fff",
    padding: "16px",
    display: "flex",
    alignItems: "flex-start",
    gap: "12px",
    height: "100%",
  },
  iconBox: (bg) => ({
    width: "48px",
    height: "48px",
    minWidth: "48px",
    backgroundColor: bg,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }),
  body: { display: "flex", flexDirection: "column", gap: "6px", width: "100%", minWidth: 0 },
  labelRow: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: "12px",
  },
  labelGroup: { display: "flex", alignItems: "center", gap: "6px", minWidth: 0 },
  label: { fontSize: "16px", fontWeight: 500, lineHeight: "160%", color: TEXT_MAIN },
  tooltipTrigger: { display: "flex", alignItems: "center", cursor: "default" },
  tooltipIcon: { width: "16px", height: "16px", display: "block" },
  amount: { fontSize: "22px", fontWeight: 600, lineHeight: "120%", color: TEXT_MAIN },
  subline: { fontSize: "13px", fontWeight: 400, color: TEXT_SUB },
  strong: { fontWeight: 600, color: TEXT_MAIN },
  divider: { borderTop: CARD_BORDER, paddingTop: "8px", marginTop: "2px" },
  twoStat: { display: "flex", gap: "20px", flexWrap: "wrap" },
  statNum: { fontSize: "22px", fontWeight: 600, lineHeight: "120%", color: TEXT_MAIN },
  statCaption: {
    fontSize: "12px",
    color: TEXT_SUB,
    display: "flex",
    alignItems: "center",
    marginTop: "2px",
  },
  deltaPill: {
    fontSize: "12px",
    fontWeight: 500,
    color: GREEN,
    backgroundColor: GREEN_TINT,
    borderRadius: "10px",
    padding: "1px 8px",
    marginInlineStart: "6px",
    whiteSpace: "nowrap",
  },
  withdrawBtn: {
    textTransform: "none",
    fontSize: "13px",
    fontWeight: 500,
    color: "#fff",
    backgroundColor: GREEN,
    borderRadius: "8px",
    padding: "5px 16px",
    boxShadow: "none",
    whiteSpace: "nowrap",
    "&:hover": { backgroundColor: "rgba(30, 118, 95, 1)", boxShadow: "none" },
    // Muted brand green instead of MUI's grey, so the card keeps its palette
    // while nothing is available to withdraw.
    "&.Mui-disabled": { color: "#fff", backgroundColor: "rgba(36, 139, 112, 0.35)" },
  },
  // Disabled buttons fire no pointer events, so the tooltip listens on this.
  withdrawTipTrigger: { display: "inline-flex", cursor: "not-allowed" },
  walletTop: {
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    alignItems: { xs: "flex-end", sm: "center" },
    gap: { xs: "6px", sm: "12px" },
  },
  balanceBox: { display: "flex", flexDirection: "column", alignItems: "flex-end" },
  balanceLabel: { fontSize: "12px", color: TEXT_SUB, whiteSpace: "nowrap" },
  balanceValue: {
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "120%",
    color: TEXT_MAIN,
    whiteSpace: "nowrap",
  },
  commStat: { display: "flex", flexDirection: "column", gap: "6px", alignItems: "flex-start" },
  avatarGroup: {
    "& .MuiAvatar-root": { width: 28, height: 28, fontSize: "12px", border: "2px solid #fff" },
  },
};

export const topFiveStyles = {
  card: {
    border: CARD_BORDER,
    borderRadius: "12px",
    backgroundColor: "#fff",
    padding: "16px",
    height: "100%",
  },
  title: {
    fontSize: "16px",
    fontWeight: 500,
    color: TEXT_MAIN,
    display: "flex",
    alignItems: "center",
    gap: "8px",
    marginBottom: "4px",
  },
  headerCell: {
    fontSize: "13px",
    color: "rgba(62, 63, 76, 0.75)",
    fontWeight: 500,
    padding: "8px",
    borderBottom: CARD_BORDER,
    whiteSpace: "nowrap",
  },
  bodyCell: {
    fontSize: "14px",
    color: "rgba(62, 63, 76, 1)",
    fontWeight: 400,
    padding: "8px",
    whiteSpace: "nowrap",
    verticalAlign: "middle",
  },
  nameCell: { display: "flex", alignItems: "center", minWidth: 0 },
  rank: { color: "rgba(62, 63, 76, 0.45)", marginInlineEnd: "10px" },
  avatar: {
    width: "28px",
    height: "28px",
    minWidth: "28px",
    borderRadius: "6px",
    backgroundColor: "rgba(242, 243, 251, 1)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "12px",
    fontWeight: 500,
    color: "rgba(62, 63, 76, 0.7)",
    marginInlineEnd: "10px",
    overflow: "hidden",
  },
  avatarImg: { width: "100%", height: "100%", objectFit: "cover" },
  money: { fontWeight: 500, color: TEXT_MAIN },
  count: { color: "rgba(62, 63, 76, 0.75)" },
};

export const setupCardStyles = {
  card: {
    border: CARD_BORDER,
    borderRadius: "12px",
    backgroundColor: "#fff",
    padding: "16px 20px",
    height: "100%",
  },
  title: { fontSize: "16px", fontWeight: 500, color: TEXT_MAIN },
  progressWrap: { marginTop: "12px", maxWidth: "420px" },
  tasks: { display: "flex", flexWrap: "wrap", gap: "10px 24px", marginTop: "16px" },
  taskRow: { display: "flex", alignItems: "center", gap: "8px" },
  taskDone: {
    fontSize: "13px",
    fontWeight: 400,
    color: "rgba(47, 43, 61, 0.4)",
    textDecoration: "line-through",
  },
  taskTodo: {
    fontSize: "13px",
    fontWeight: 400,
    color: TEXT_MAIN,
    textDecoration: "underline",
    cursor: "pointer",
    transition: "color 0.2s ease-in-out",
    "&:hover": { color: "rgba(70, 160, 145, 1)" },
  },
};

export const healthStyles = {
  card: {
    border: CARD_BORDER,
    borderRadius: "12px",
    backgroundColor: "#fff",
    padding: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "12px",
    height: "100%",
  },
  main: { display: "flex", flexDirection: "column", gap: "6px", minWidth: 0 },
  labelRow: { display: "flex", alignItems: "center", gap: "6px" },
  label: { fontSize: "13px", fontWeight: 400, color: TEXT_SUB },
  value: { fontSize: "24px", fontWeight: 600, lineHeight: "120%" },
  pill: {
    alignSelf: "flex-start",
    fontSize: "12px",
    fontWeight: 500,
    padding: "2px 10px",
    borderRadius: "10px",
    marginTop: "2px",
  },
  trend: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    paddingLeft: "12px",
    borderLeft: CARD_BORDER,
    minWidth: "84px",
  },
  trendRow: { display: "flex", justifyContent: "space-between", gap: "10px" },
  trendMonth: { fontSize: "11px", color: "rgba(62, 63, 76, 0.55)" },
  trendVal: { fontSize: "11px", fontWeight: 500, color: "rgba(62, 63, 76, 0.9)" },
};
